import { Container } from '@/components/container';
import { cn } from '@/utils/cn';

import { CATEGORIES } from '../tech-tag/constants';
import { Category } from '../tech-tag/types';

type Props = {
    onSelect: (category: Category) => void;
    selectedCategory: Category;
};

export const Menu = ({ onSelect, selectedCategory }: Props) => (
    <Container>
        <div
            className={`
              my-10 hidden w-full items-center justify-center gap-8

              sm:flex
            `}
        >
            {CATEGORIES.map((category) => (
                <p
                    className={cn(
                        `
                          typography-sub-heading flex size-40 shrink-0
                          cursor-pointer items-center justify-center
                          rounded-full border px-4 py-2 font-bold
                        `,
                        category === selectedCategory
                            ? 'border-2'
                            : 'border-primary-darkgray text-primary-darkgray',
                    )}
                    onClick={() => onSelect(category)}
                    key={category}
                >
                    {category}
                </p>
            ))}
        </div>
    </Container>
);
